import { SubscriptionPaymentMethod } from './Subscriptions.js';

class SubscriptionsMapper {
  static createSubscriptionModelFromResponse(data) {
    const commonProperties = {
      state: data.state,
      currentBillingAmount: data.current_billing_amount,
      currentBillingCurrency: data.current_billing_currency,
      currentPeriodEndsAt: data.current_period_ends_at,
      paymentMethodId: data.payment_method_id,
      plan: this.createSubscriptionPlanModelFromResponse(data.plan),
      retentionDiscount: data.retention_discount ? this.createRetentionDiscountInfoFromResponse(data.retention_discount) : null
    };
    if (data.payment_method === SubscriptionPaymentMethod.CREDITCARD) {
      return {
        ...commonProperties,
        paymentMethod: data.payment_method,
        cardLastFour: data.card_last_four,
        cardExpiration: `${data.card_exp_month}/${data.card_exp_year}`,
        cardType: data.card_type
      };
    } else {
      return {
        ...commonProperties,
        paymentMethod: data.payment_method,
        paypalAccountEmail: data.paypal_account_email
      };
    }
  }
  static createSubscriptionPlanModelFromResponse(data) {
    const createPricingModel = data => ({
      currency: data.currency,
      unitAmount: data.unit_amount
    });
    const createRampIntervalModel = data => ({
      startBillingCycle: data.start_billing_cycle,
      rampPricings: data.ramp_pricings.map(createPricingModel)
    });
    return {
      id: data.id,
      code: data.code,
      name: data.name,
      intervalUnit: data.interval_unit,
      intervalLength: data.interval_length,
      pricingType: data.pricing_type,
      rampIntervals: data.ramp_intervals && data.ramp_intervals.length > 0 ? data.ramp_intervals.map(createRampIntervalModel) : undefined,
      fixedPricing: data.fixed_pricing && createPricingModel(data.fixed_pricing)
    };
  }
  static createSubscriptionPlanPriceFromResponse(data) {
    return {
      planCode: data.plan_code,
      currency: data.currency,
      total: data.total,
      subtotal: data.subtotal,
      taxes: data.taxes,
      intervalUnit: data.interval_unit
    };
  }
  static createSubscriptionRetentionDiscountFromResponse(data) {
    return {
      eligible: data.eligible,
      discount: data.discount,
      currentAmount: data.current_amount,
      discountedAmount: data.discounted_amount
    };
  }
  static createAppliedRetentionDiscountFromResponse(data) {
    return {
      success: data.success,
      currentPeriodEndsAt: data.current_period_ends_at,
      currentAmount: data.current_amount,
      discountedAmount: data.discounted_amount,
      currency: data.currency
    };
  }
  static createRetentionDiscountInfoFromResponse(data) {
    return {
      active: data.active,
      redeemedAt: data.redeemed_at,
      periodEndsAt: data.period_ends_at
    };
  }
}

export { SubscriptionsMapper };
//# sourceMappingURL=SubscriptionsMapper.js.map
